import styled from 'styled-components';

import { Button } from '@sternum/ui';
import { Colors } from '@sternum/web/components/theme/constants';
import { ct } from '@sternum/web/utils/theme';

export const ButtonStyled = styled(Button)`
  font-size: 12px;
  color: ${ct({ Dark: Colors.BrandBlueLightest, Light: Colors.BrandBlue })};
`;
